import {
    applicationStore,
    freeBetStore,
    gameConfigStore,
    gameResultStore,
    lobbyStore,
    notificationStore,
    popupStore,
    roundInfoStore,
    statisticsStore,
    userCountStore,
    userInfoStore,
} from '@pascal/pascal-core/shared/core/store';

import {gameStore} from '../store/gameStore';
import {doChipStore} from '../store/doChipStore';
import {roundTimeStore} from '../store/roundTimeStore';
import {limitsAndPayoutsStore} from '../store/limitsAndPayoutsStore';

import {worker} from '../index';
import {gameLiveConnection} from './GameConnection';
import {
    ApiServices,
    ApiServiceTypes,
    DefaultQueryParams, iframeService,
    loadingStore,
    parseNumberByPrecision,
    parseQuery, platformMessageStore,
    RoundStatus,
} from '@pascal/pascal-core';
import {winningAmountStore} from '../store/winningAmountStore';
import {PopUps} from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import {userSettingsStore} from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import {soundService, soundTypes} from './SoundService';
import {autoBetStore} from '../store/autoBetStore';
import {videoInfoStore} from '../store/videoInfoStore';
import {allChipsTotal} from '../helpers/chipsTotal';
// import animationController from '../roullette-animation/src/animations/controller';
import {userWinCountStore} from '@pascal/pascal-core/shared/core/store';
import {favoriteBetsStore} from '../store/favoriteBetsStore';
import {REC_BET_DATA_MODEL} from '../enums/tableNumbers';
import {getKeyByValue} from '../helpers/getKeyByValue';
import {marketType} from '../enums/marketType';
import {liveConnection} from '../core';
import {PASCAL_PLATFORM_ID} from '../enums/constants';
import {betShopStore} from '../store/betShopStore';
import {BET_SHOP_GAME_ID} from '../enums/constants';
import {tableBetHistoryStore} from '@pascal/pascal-core/shared/core/store/tableBetHistoryStore';
import {mathConfig, mathJS} from '../helpers/mathFormat';
import {ballState, updateBallPositionForKeepSameNumberOnRouletteDisk} from '../rouletteCanvas/ball';
import {rouletteGame, sceneObjects} from '../rouletteCanvas';
import {GameModes} from '../enums/gameModes';
import {getNumberAngle} from '../rouletteCanvas/utils';
import {DIRECTIONS, SCENE_OBJ_NAMES} from '../rouletteCanvas/constants';
import {animationService} from '../rouletteCanvas/animationService';
import {betResponseCodeByName} from "../enums/betResponseCode";
import {PlatformErrorCodes} from "../enums/platformEnums";

let rouletteAnimation;
let ballAnimation;
let animationDefaultDuration = 10;
let timeOutId;
const {[DefaultQueryParams.GameId]: gameId} = parseQuery(window.location.search);
const isBetShop = +gameId === BET_SHOP_GAME_ID;

class GameService {
    static ReconnectCount = 0;

    async onGetInitialStateResult({
                                      roundInfo,
                                      results,
                                      gameConfiguration,
                                      limits,
                                      rate,
                                      precision,
                                      currencyCode,
                                      balance,
                                      isTestPlatform,
                                      currentBets,
                                      statistics,
                                      userFreebets,
                                      gameTypes,
                                  }) {
        iframeService.sendBalanceUpdated(balance);
        applicationStore.setUseDemoByBackendLogic(false);
        freeBetStore.setIsFreeChip(true);
        platformMessageStore.setDelayForPostMessageRoundFinished(6000);

        const {[DefaultQueryParams.PartnerId]: partnerId, [DefaultQueryParams.Mode]: mode} = parseQuery(
            window.location.search
        );
        if (+partnerId === PASCAL_PLATFORM_ID) {
            applicationStore.setIsTestPlatform(true);
        } else {
            applicationStore.setIsTestPlatform(isTestPlatform);
        }
        if (mode === GameModes.FUN) {
            applicationStore.setIsDemo(true);
        }

        const roomName =
            !isBetShop && gameConfiguration?.partnerGameConfig
                ? gameConfiguration.partnerGameConfig?.gameTypes?.find((item) => item.gameTypeId === gameConfigStore.gameTypeId)
                    .name
                : 'Black';

        rouletteGame(roomName);

        lobbyStore.setRoomName(roomName);
        gameStore.setGameTypes(gameTypes);

        const trySetBallOnDiskForInitial = (statusCode) =>
            setTimeout(() => {
                if (!sceneObjects.get(SCENE_OBJ_NAMES.ball)) {
                    trySetBallOnDiskForInitial(statusCode);
                    return;
                }
                for (let i = 0; i < results.length; i++) {
                    if (results[i].status === statusCode) {
                        ballState.isStayOnRouletteDisk = true;
                        const targetAngle = getNumberAngle(results[i].roundData.number);
                        updateBallPositionForKeepSameNumberOnRouletteDisk(targetAngle);
                        break;
                    }
                }
            }, 500);

        if (roundInfo?.lastFinishedRound && gameStore.isBetsClosed) {
            winningAmountStore.setWinNumber(roundInfo.lastFinishedRound.roundData.number);

            setTimeout(() => {
                winningAmountStore.clearWinInfo();
            }, 1500);
        }

        if (roundInfo.second > 0) {
            trySetBallOnDiskForInitial(2);
        } else if (roundInfo.second > -5) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].status === 4) {
                    // spin({num: results[i].roundData.number, isShortAnimation: true});
                    break;
                }
            }
        } else {
            trySetBallOnDiskForInitial(4);
        }

        if (!isBetShop) {
            winningAmountStore.setLastWin(0);
            favoriteBetsStore.setFavoriteBes([]);
            doChipStore.resetReBet();
            doChipStore.resetAllBetsModels();
            freeBetStore.resetActiveFreeBet();
            winningAmountStore.setWinningAmount(null);
            // winningAmountStore.setWinNumber(null);
            autoBetStore.resetAutoBet();
            gameStore.setIsBetsClosed(false);
            statisticsStore.setStatistics({});
            gameStore.setIsShowAutoPlay(gameConfiguration.config?.autoplay);
        }
        if (
            roundInfo.status !== RoundStatus.Started ||
            (roundInfo.second < 0 && roundInfo.status === RoundStatus.Started)
        ) {
            betShopStore.setIsShowStatistic(true);
            gameStore.setIsBetsClosed(true);
            roundTimeStore.setTime(null);
        }

        if (isBetShop) {
            betShopStore.setBetShopStatistic(statistics);
            this.handleRouletteAnimation({roundInfo, currentBets, results});
        }

        if (roundInfo.second > 0) {
            const time = Math.floor(Math.abs(roundInfo.second));
            roundTimeStore.setTime(time);
            roundTimeStore.setBetShopTime(time);
            this.sendWorker(time);
        }

        if (!isBetShop) {
            userInfoStore.setUserInfo({
                ...userInfoStore,
                rate,
                precision,
                currencyCode,
                balance,
            });
        }

        const {userId} = userInfoStore;
        const userBets = currentBets?.find((bet) => +bet?.userId === +userId);
        roundInfoStore.setRoundInfo(roundInfo);
        gameResultStore.setGameResults(results);
        if (!isBetShop) {
            if (userBets?.freeBetId) {
                freeBetStore.setActivateFreeBet(userFreebets.find((item) => item.id === userBets.freeBetId));
            }
            if (userBets?.betData) {
                doChipStore.setReBetInitial(this.handleGetOrderedBets(userBets.betData, true));
            }
            this.handleRouletteAnimation({roundInfo, currentBets, results, userBets});
            gameConfigStore.setLimits(limits);
            limitsAndPayoutsStore.setLimitsAndPayouts(gameConfiguration.limitsAndPayouts);
            doChipStore.setQuickBets(limits.quickBets);
            if (!freeBetStore.activeFreeBet.id) {
                doChipStore.setSelectedChip(limits.quickBets[0]);
            }
            if (currentBets) {
                userCountStore.setUsersCount(currentBets.length || 0);
            }
            userWinCountStore.setUserWiningBets(null);
        }

        if (loadingStore.isAdditionalLoading) {
            setTimeout(() => {
                loadingStore.updateIsAdditionalLoading(false);
            }, 1000);
        }
        popupStore.toggleReconnect(false);
        popupStore.onConnectionError(false);
        popupStore.close();
        loadingStore.updateLoading({isGameInitialLoaded: true});

        // setTimeout(() => {
        //   if (popupStore.popupName) {
        //     popupStore.toggleReconnect(false);
        //     popupStore.close();
        //   }
        // }, 1500);
    }

    handleDoBetResult(data) {
        const {userId, balance} = userInfoStore;
        if (data.responseCode === 0) {
            iframeService.sendBalanceUpdated(balance);
        }

        userCountStore.setUsersCount(data.betData.length ? userCountStore.usersCount + 1 : userCountStore.usersCount);
        if (+data.userId === +userId) {
            doChipStore.setReBet();
            if (userSettingsStore.isSoundOn) {
                soundService.playBetAccepted();
            }

            notificationStore.setNotificationType(data.responseCode);
            setTimeout(() => {
                notificationStore.setNotificationType(null);
            }, 1000);
        }
    }

    handleDoBetResultValidation({responseCode}) {
        doChipStore.resetAllBetsModels();
        autoBetStore.resetAutoBet();
        if (responseCode === betResponseCodeByName.NotEnoughBalance) {
            !platformMessageStore.isShowAllNotification ? iframeService.sendErrorReceived(
                {"errorCode": PlatformErrorCodes.NotEnoughMoney}
            ) : notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance)
        }

        setTimeout(() => {
            notificationStore.setNotificationType(null);
        }, 1000);
    }

    handleRoundStart({data: {statistics, newRound, startedRound}}) {
        iframeService.sendBalanceUpdated(userInfoStore.balance);

        if (isBetShop) {
            roundTimeStore.setBetShopTime(startedRound.duration)
            betShopStore.setIsShowStatistic(true);
            winningAmountStore.setWinNumber(null);
            roundInfoStore.setRoundId(startedRound.roundId);
            betShopStore.setBetShopStatistic(statistics);
            videoInfoStore.setIsVideoOpen(false);
            if (videoInfoStore.isVideoAuto) {
                // isBetShop ? loadThree.camera3() : loadThree.camera2();
            }
            this.sendWorker(roundInfoStore.duration);
        } else {
            const {balance} = userInfoStore;
            userCountStore.setUsersCount(0);
            doChipStore.resetAllBetsModels();
            winningAmountStore.clearWinInfo();
            gameStore.setIsBetsClosed(false);
            roundInfoStore.setRoundId(startedRound.roundId);
            gameResultStore.setGameResults([newRound, ...gameResultStore.gameResults]);
            statisticsStore.setStatistics({...statisticsStore.statistics, ...statistics});
            this.sendWorker(roundInfoStore.duration);
            videoInfoStore.setIsVideoOpen(false);
            const {autoBetModel} = autoBetStore;
            if (autoBetModel && autoBetModel.autoBetCount && allChipsTotal(autoBetModel.betModel) < balance) {
                doChipStore.setAllBetsModel([autoBetModel.betModel]);
                autoBetStore.setAutoBetCount();
                winningAmountStore.setLastWin(0);
            } else {
                autoBetStore.setIsPlay(false);
            }
            userWinCountStore.setUserWiningBets(null);
        }
    }

    async handleGetBalance() {
        const {
            data: {result},
        } = await ApiServices.get(ApiServiceTypes.UsersService).getBalance();
        if (result) {
            userInfoStore.setBalance(result.balance);
        }
    }

    async handleRoundFin(data) {
        const {
            data: {
                finishedRound: {
                    roundData: {number, navigation, animationNumber},
                },
            },
        } = data;


        gameLiveConnection.getBalance()

        setTimeout(() => {
            iframeService.sendBalanceUpdated(userInfoStore.balance);
        }, 8000)

        const direction = navigation === 1 ? DIRECTIONS.RIGHT : DIRECTIONS.LEFT;
        animationService.spin({num: number, direction});
        animationService.setBallAnimationCallBack(() => this.handleBallAnimationComplete(data));
    }

    handleBallAnimationComplete({data: {finishedRound, bets}}) {
        const {userId} = userInfoStore;
        winningAmountStore.setWinNumber(finishedRound.roundData.number);
        this.updateResultsAndWinNumber(finishedRound);

        if (!isBetShop) {
            const updatedResults = [...gameResultStore.gameResults].map((item) =>
                +item.roundId === +finishedRound.id
                    ? {
                        ...finishedRound,
                        roundId: finishedRound.id,
                    }
                    : {...item}
            );
            gameResultStore.setGameResults(updatedResults);
        }
        gameStore.setIsAnimationComplete(false);

        if (!isBetShop) {
            const {gameTypeId} = gameConfigStore;
            const userBets = bets.find((bet) => +bet.userId === +userId);
            if (userBets && !applicationStore.isDemo) {
                tableBetHistoryStore.handleBetHistoryUpdate();
                if (+gameTypeId === +finishedRound?.gameTypeId) {
                    this.handleBetWinning(userBets?.additionalParams, true, true);
                }
                if (userBets?.freeBetId) {
                    freeBetStore.freeBetTotalWinCalculator(userBets);
                }
            }
            if (applicationStore.isDemo && doChipStore.getAllBetsModels.length) {
                this.handleDemoRoundFinish(finishedRound.roundData.number);
            }
            const winingUsers = bets.filter((item) => item.winAmount !== 0);
            if (winingUsers.length) {
                winingUsers.sort((a, b) => b.winAmount - a.winAmount);
                userWinCountStore.setUserWiningBets(winingUsers);
            }
        }
        // if (!isBetShop) {
        //   if (!applicationStore.isDemo && userId) {
        //     gameLiveConnection.getBalance();
        //   }
        // }
    }

    handleBetsClosed({data: {gameTypeId, roundId}}) {
        const {activeFreeBet} = freeBetStore;
        gameStore.setIsNotification();
        if (isBetShop) {
            betShopStore.setIsShowStatistic(false);
        }
        if (videoInfoStore.isVideoAuto) {
            if (isBetShop) {
                // loadThree.camera4();
            } else {
                // loadThree.camera1();
            }
        }

        if (!isBetShop) {
            const bets = doChipStore.getAllBetsModels[0];
            const {balance, setDemoBalance} = userInfoStore;
            if (bets && bets.betModel && !applicationStore.isDemo) {
                gameLiveConnection.doBet(
                    activeFreeBet.id
                        ? {
                            betData: bets.betModel,
                            roundId,
                            gameTypeId,
                            freeBetId: activeFreeBet.id,
                        }
                        : {
                            betData: bets.betModel,
                            roundId,
                            gameTypeId,
                        }
                );
            }
            if (applicationStore.isDemo && bets) {
                doChipStore.setReBet();
                if (userSettingsStore.isSoundOn) {
                    soundService.playBetAccepted();
                }
                notificationStore.setNotificationType(0);
                setTimeout(() => {
                    notificationStore.setNotificationType(null);
                }, 1000);
                setDemoBalance(
                    parseNumberByPrecision(
                        1,
                        +mathJS.format(balance - (allChipsTotal(doChipStore.getAllBetsModels[0]) || 0), mathConfig)
                    )
                );
            }
        }
        gameStore.setIsBetsClosed(true);
        roundTimeStore.setTime(null);
        videoInfoStore.setIsVideoOpen(true);
        gameStore.setIsAnimationComplete(true);
    }

    handleBalanceUpdate(data) {
        userInfoStore.setBalance(data);
    }

    socketRecursiveReconnecting() {
        try {
            liveConnection
                .restartGameConnection()
                .then((connectionData) => {
                    liveConnection.connectionInitCallback(connectionData);
                    clearTimeout(timeOutId);
                })
                .catch(() => {
                    timeOutId = setTimeout(() => {
                        this.socketRecursiveReconnecting();
                    }, 4000);
                });
        } catch (err) {
            popupStore.onConnectionError(true);
        }
    }

    handleReconnecting(error) {
        if (error && error.message) {
            popupStore.toggleReconnect();
        } else {
            GameService.ReconnectCount += 1;
            popupStore.toggleReconnect();
        }
    }

    handleReconnected() {
        GameService.ReconnectCount = 0;
        if (popupStore.popupName !== PopUps.ConnectionError) {
            gameLiveConnection.sendGameGetInitialState(false).then(() => {
            });
        }
    }

    handleConnectionError() {
        if (GameService.ReconnectCount) {
            // popupStore.open({ name: PopUps.ConnectionError });
            popupStore.onConnectionError(true);
        }
    }

    countDown({data: time}) {
        roundTimeStore.setTime(time);
    }

    sendWorker(timerValue) {
        if (timerValue) {
            worker.addEventListener('message', this.countDown);
            worker.postMessage(timerValue);
        } else {
            worker.removeEventListener('message', this.countDown);
        }
    }

    handleGetOrderedBets(additionalParams, isWithOutWin) {
        return additionalParams.reduce((acc, cur) => {
            const {market, includedMarkets} = cur;
            if (includedMarkets) {
                const betWithOutWin = includedMarkets.map((item) => {
                    const {winAmount, ...all} = item;
                    return all;
                });
                acc.push({
                    bet: market,
                    includedBets: isWithOutWin ? betWithOutWin : includedMarkets,
                });
            } else {
                const {winAmount, ...all} = market;
                acc.push({
                    bet: isWithOutWin ? all : market,
                });
            }
            return acc;
        }, []);
    }

    handleBetsOrdering(additionalParams, isWithOutWin, isInitial = true) {
        const betsModel = this.handleGetOrderedBets(additionalParams, isWithOutWin);
        setTimeout(() => {
            doChipStore.setAllBetsModel(
                [
                    {
                        betModel: betsModel,
                    },
                ],
                isInitial
            );
        }, 1000);
    }

    handleBetWinning(additionalParams, isInitial = true, isInRoundFin = false) {
        const {balance, setDemoBalance} = userInfoStore;
        let result = [];
        this.handleBetsOrdering(additionalParams, false, isInitial);
        additionalParams?.forEach((item) => {
            const {includedMarkets, market} = item;
            if (includedMarkets) {
                result = [...result, ...includedMarkets];
                return;
            }
            result.push(market);
        });
        const winAmounts = result.reduce((acc, cur) => {
            const {winAmount} = cur;
            if (winAmount) {
                acc = +mathJS.format(acc + winAmount, mathConfig);
            }
            return parseNumberByPrecision(1, +acc);
        }, 0);

        winningAmountStore.setWinningAmount(winAmounts, !isInitial);
        winningAmountStore.setLastWin(winAmounts);
        if (applicationStore.isDemo) {
            setDemoBalance(parseNumberByPrecision(1, +mathJS.format(balance + winAmounts, mathConfig)));
        }
    }

    handleBallAnimationCompleteInitial(currentBets, results, roundInfo) {
        const {userId} = userInfoStore;
        // this.updateResultsAndWinNumber(finishedRound);
        winningAmountStore.setWinNumber(roundInfo.lastFinishedRound.roundData.number);
        if (videoInfoStore.isVideoAuto) {
            // isBetShop ? loadThree.camera3() : loadThree.camera2();
        }
        // const updatedResults = [...gameResultStore.gameResults].map(
        //   item => +item.roundId === +finishedRound.id ? {
        //     ...finishedRound,
        //     roundId: finishedRound.id,
        //   } : {...item});
        // gameResultStore.setGameResults(updatedResults);
        const userBets = currentBets.find((bet) => +bet.userId === +userId);
        if (userBets && !applicationStore.isDemo) {
            this.handleBetWinning(userBets?.betData);
        }
        const winingUsers = currentBets.filter((item) => item.winAmount !== 0);
        if (winingUsers.length) {
            winingUsers.sort((a, b) => b.winAmount - a.winAmount);
            userWinCountStore.setUserWiningBets(winingUsers);
        }
        setTimeout(() => {
            winningAmountStore.clearWinInfo();
            userCountStore.setUsersCount(0);
            doChipStore.resetAllBetsModels();
            winningAmountStore.setWinningAmount(null);
            winningAmountStore.setWinNumber(null);
        }, 2000);

        if (!applicationStore.isDemo && userId) {
            gameLiveConnection.getBalance();
        }
    }

    updateResultsAndWinNumber(finishedRound) {
        winningAmountStore.setWinNumber(finishedRound.roundData.number);
        const updatedResults = [...gameResultStore.gameResults].map((item) =>
            +item.roundId === +finishedRound.id
                ? {
                    ...finishedRound,
                    roundId: finishedRound.id,
                }
                : {...item}
        );
        gameResultStore.setGameResults(updatedResults);
    }

    handleDemoRoundFinish(number) {
        const findCurrentOdd = (type) => {
            return limitsAndPayoutsStore.limitsPayouts.find((item) => {
                if (item.marketType.includes('/')) {
                    const searchedValue = item.marketType.split('/');
                    return searchedValue.some((item) => type.toLowerCase().match(item.toLowerCase()));
                }
                return type.toLowerCase().match(item.marketType.toLowerCase());
            }).odd;
        };

        if (doChipStore.getAllBetsModels.length) {
            const {betModel} = doChipStore.getAllBetsModels[0];
            const result = betModel.reduce((acc, cur) => {
                const {bet: market, includedBets: includedMarkets} = cur;
                if (includedMarkets) {
                    const result = includedMarkets.reduce(
                        (initial, bet) => {
                            const type = getKeyByValue(marketType, bet.type);
                            const odd = findCurrentOdd(type);
                            const isBetWin = REC_BET_DATA_MODEL.find((item) => type === item.type).winNumbers.includes(number);
                            initial.includedMarkets.push({
                                ...bet,
                                winAmount: parseNumberByPrecision(1, +mathJS.format(isBetWin ? bet.amount * odd : 0, mathConfig)),
                            });
                            initial.market.winAmount =
                                initial.market.winAmount +
                                parseNumberByPrecision(1, +mathJS.format(isBetWin ? bet.amount * odd : 0, mathConfig));
                            return initial;
                        },
                        {
                            includedMarkets: [],
                            market: {...market, winAmount: 0},
                        }
                    );
                    acc.push(result);
                } else {
                    const type = getKeyByValue(marketType, market.type);
                    const odd = findCurrentOdd(type);
                    const isBetWin = REC_BET_DATA_MODEL.find((item) => type === item.type).winNumbers.includes(number);
                    acc.push({
                        market: {
                            ...market,
                            winAmount: parseNumberByPrecision(1, +mathJS.format(isBetWin ? market.amount * odd : 0, mathConfig)),
                        },
                    });
                }

                return acc;
            }, []);
            this.handleBetWinning(result, false);
        }
    }

    handleRouletteAnimation({roundInfo, currentBets, results, userBets}) {
        ballState.onBallAnimationComplete = () => {
            if (isBetShop) {
                winningAmountStore.setWinNumber(roundInfo.lastFinishedRound?.roundData.number);
                setTimeout(() => {
                    winningAmountStore.setWinNumber(null);
                }, 2000);
            } else {
                if (gameStore.isBetsClosed) {
                    this.handleBallAnimationCompleteInitial(currentBets, results, roundInfo);
                }
            }
        };

        if (
            (roundInfo.status === RoundStatus.Started && roundInfo.second > 0) ||
            roundInfo.second < -animationDefaultDuration
        ) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(true);
            }
        } else if (roundInfo.status === RoundStatus.Started && roundInfo.second < 0) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(false);
                if (videoInfoStore.isVideoAuto) {
                    if (isBetShop) {
                        // loadThree.camera4();
                    } else {
                        // loadThree.camera1();
                    }
                }
            }
            if (userBets) {
                this.handleBetsOrdering(userBets?.betData, true);
            }
        } else if (
            roundInfo.second < 0 &&
            roundInfo.status === RoundStatus.OnFinish &&
            Math.abs(roundInfo.second) < animationDefaultDuration
        ) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(false);
            }
            const time = Math.abs(roundInfo.second + roundInfo.betsClosedDuration);
            if (videoInfoStore.isVideoAuto) {
                if (isBetShop) {
                    // loadThree.camera4();
                } else {
                    // loadThree.camera1();
                }
            }
            if (userBets) {
                this.handleBetsOrdering(userBets?.betData, true);
            }
        }
    }

    handleReplay(repliedBetData) {
        doChipStore.setQuickBets([0.5, 2.5, 5.0, 10.0, 50.0, 100.0]);
        this.handleBetsOrdering(repliedBetData.additionalParams, true);
        gameStore.setIsBetsClosed(true);
        animationController.args = {
            animation: repliedBetData.roundData.animationNumber,
            navigation: Boolean(repliedBetData.roundData.navigation),
            index: repliedBetData.roundData.number,
            curentScene: 1,
            duration: 10,
            second: 0,
            onBallAnimationComplete: () => {
                this.handleBallAnimationCompleteReplay(repliedBetData);
            },
            onRouletteAnimationComplete: () => {
            },
        };
        rouletteAnimation = animationController.getRouletteAnimation();
        rouletteAnimation.timeline.play();
        if (!isBetShop) {
            soundService.play(soundTypes.ballAnimation);
        }
        ballAnimation = animationController.getBallAnimation();
        ballAnimation.timeline.play();
    }

    handleBallAnimationCompleteReplay(repliedBetData) {
        winningAmountStore.setWinNumber(repliedBetData.roundData.number);
        this.handleBetWinning(repliedBetData?.additionalParams);
        setTimeout(() => {
            // loadThree.camera2();
        }, 1000);
    }

    handleGetOrderedBets(additionalParams, isWithOutWin) {
        return additionalParams.reduce((acc, cur) => {
            const {market, includedMarkets} = cur;
            if (includedMarkets) {
                const betWithOutWin = includedMarkets.map((item) => {
                    const {winAmount, ...all} = item;
                    return all;
                });
                acc.push({
                    bet: market,
                    includedBets: isWithOutWin ? betWithOutWin : includedMarkets,
                });
            } else {
                const {winAmount, ...all} = market;
                acc.push({
                    bet: isWithOutWin ? all : market,
                });
            }
            return acc;
        }, []);
    }

    handleBetsOrdering(additionalParams, isWithOutWin, isInitial = true) {
        const betsModel = this.handleGetOrderedBets(additionalParams, isWithOutWin);
        setTimeout(() => {
            doChipStore.setAllBetsModel(
                [
                    {
                        betModel: betsModel,
                    },
                ],
                isInitial
            );
        }, 1000);
    }

    handleBetWinning(additionalParams, isInitial = true) {
        const {balance, setDemoBalance} = userInfoStore;
        let result = [];
        this.handleBetsOrdering(additionalParams, false, isInitial);

        additionalParams?.forEach((item) => {
            const {includedMarkets, market} = item;
            if (includedMarkets) {
                result = [...result, ...includedMarkets];
                return;
            }
            result.push(market);
        });
        const winAmounts = result.reduce((acc, cur) => {
            const {winAmount} = cur;
            if (winAmount) {
                acc = +mathJS.format(acc + winAmount, mathConfig);
            }
            return parseNumberByPrecision(1, +acc);
        }, 0);

        iframeService.sendWinUpdate(winAmounts);
        winningAmountStore.setWinningAmount(winAmounts, !isInitial);
        winningAmountStore.setLastWin(winAmounts);
        if (applicationStore.isDemo) {
            setDemoBalance(parseNumberByPrecision(1, +mathJS.format(balance + winAmounts, mathConfig)));
        }
    }

    handleBallAnimationCompleteInitial(currentBets, results, roundInfo) {
        const {userId} = userInfoStore;
        // this.updateResultsAndWinNumber(finishedRound);
        winningAmountStore.setWinNumber(roundInfo.lastFinishedRound.roundData.number);
        if (videoInfoStore.isVideoAuto) {
            // isBetShop ? loadThree.camera3() : loadThree.camera2();
        }
        // const updatedResults = [...gameResultStore.gameResults].map(
        //   item => +item.roundId === +finishedRound.id ? {
        //     ...finishedRound,
        //     roundId: finishedRound.id,
        //   } : {...item});
        // gameResultStore.setGameResults(updatedResults);
        const userBets = currentBets.find((bet) => +bet.userId === +userId);
        if (userBets && !applicationStore.isDemo) {
            this.handleBetWinning(userBets?.betData);
        }
        const winingUsers = currentBets.filter((item) => item.winAmount !== 0);
        if (winingUsers.length) {
            winingUsers.sort((a, b) => b.winAmount - a.winAmount);
            userWinCountStore.setUserWiningBets(winingUsers);
        }
        setTimeout(() => {
            winningAmountStore.clearWinInfo();
            userCountStore.setUsersCount(0);
            doChipStore.resetAllBetsModels();
            winningAmountStore.setWinningAmount(null);
            winningAmountStore.setWinNumber(null);
        }, 2000);
        if (!applicationStore.isDemo && userId) {
            gameLiveConnection.getBalance();
        }
    }

    updateResultsAndWinNumber(finishedRound) {
        winningAmountStore.setWinNumber(finishedRound.roundData.number);
        const updatedResults = [...gameResultStore.gameResults].map((item) =>
            +item.roundId === +finishedRound.id
                ? {
                    ...finishedRound,
                    roundId: finishedRound.id,
                }
                : {...item}
        );
        gameResultStore.setGameResults(updatedResults);
    }

    handleDemoRoundFinish(number) {
        const findCurrentOdd = (type) => {
            return limitsAndPayoutsStore.limitsPayouts.find((item) => {
                if (item.marketType.includes('/')) {
                    const searchedValue = item.marketType.split('/');
                    return searchedValue.some((item) => type.toLowerCase().match(item.toLowerCase()));
                }
                return type.toLowerCase().match(item.marketType.toLowerCase());
            }).odd;
        };
        if (doChipStore.getAllBetsModels.length) {
            const {betModel} = doChipStore.getAllBetsModels[0];
            const result = betModel.reduce((acc, cur) => {
                const {bet: market, includedBets: includedMarkets} = cur;
                if (includedMarkets) {
                    const result = includedMarkets.reduce(
                        (initial, bet) => {
                            const type = getKeyByValue(marketType, bet.type);
                            const odd = findCurrentOdd(type);
                            const isBetWin = REC_BET_DATA_MODEL.find((item) => type === item.type).winNumbers.includes(number);
                            initial.includedMarkets.push({
                                ...bet,
                                winAmount: parseNumberByPrecision(1, +mathJS.format(isBetWin ? bet.amount * odd : 0, mathConfig)),
                            });
                            initial.market.winAmount =
                                initial.market.winAmount +
                                parseNumberByPrecision(1, +mathJS.format(isBetWin ? bet.amount * odd : 0, mathConfig));
                            return initial;
                        },
                        {
                            includedMarkets: [],
                            market: {...market, winAmount: 0},
                        }
                    );
                    acc.push(result);
                } else {
                    const type = getKeyByValue(marketType, market.type);
                    const odd = findCurrentOdd(type);
                    const isBetWin = REC_BET_DATA_MODEL.find((item) => type === item.type).winNumbers.includes(number);
                    acc.push({
                        market: {
                            ...market,
                            winAmount: parseNumberByPrecision(1, +mathJS.format(isBetWin ? market.amount * odd : 0, mathConfig)),
                        },
                    });
                }
                return acc;
            }, []);
            this.handleBetWinning(result, false);
        }
    }

    handleRouletteAnimation({roundInfo, currentBets, results, userBets}) {
        ballState.onBallAnimationComplete = () => {
            if (isBetShop) {
                winningAmountStore.setWinNumber(roundInfo.lastFinishedRound?.roundData.number);
                setTimeout(() => {
                    winningAmountStore.setWinNumber(null);
                }, 2000);
            } else {
                if (gameStore.isBetsClosed) {
                    this.handleBallAnimationCompleteInitial(currentBets, results, roundInfo);
                }
            }
        };
        if (
            (roundInfo.status === RoundStatus.Started && roundInfo.second > 0) ||
            roundInfo.second < -animationDefaultDuration
        ) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(true);
            }
        } else if (roundInfo.status === RoundStatus.Started && roundInfo.second < 0) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(false);
                if (videoInfoStore.isVideoAuto) {
                    if (isBetShop) {
                        // loadThree.camera4();
                    } else {
                        // loadThree.camera1();
                    }
                }
            }
            if (userBets) {
                this.handleBetsOrdering(userBets?.betData, true);
            }
        } else if (
            roundInfo.second < 0 &&
            roundInfo.status === RoundStatus.OnFinish &&
            Math.abs(roundInfo.second) < animationDefaultDuration
        ) {
            if (isBetShop) {
                betShopStore.setIsShowStatistic(false);
            }
            if (videoInfoStore.isVideoAuto) {
                if (isBetShop) {
                    // loadThree.camera4();
                } else {
                    // loadThree.camera1();
                }
            }
            if (userBets) {
                this.handleBetsOrdering(userBets?.betData, true);
            }
        }
    }

    handleReplay(repliedBetData) {
        doChipStore.setQuickBets([0.5, 2.5, 5.0, 10.0, 50.0, 100.0]);
        this.handleBetsOrdering(repliedBetData.additionalParams, true);
        gameStore.setIsBetsClosed(true);
        animationController.args = {
            animation: repliedBetData.roundData.animationNumber,
            navigation: Boolean(repliedBetData.roundData.navigation),
            index: repliedBetData.roundData.number,
            curentScene: 1,
            duration: 10,
            second: 0,
            onBallAnimationComplete: () => {
                this.handleBallAnimationCompleteReplay(repliedBetData);
            },
            onRouletteAnimationComplete: () => {
            },
        };
        rouletteAnimation = animationController.getRouletteAnimation();
        rouletteAnimation.timeline.play();
        if (!isBetShop) {
            soundService.play(soundTypes.ballAnimation);
        }
        ballAnimation = animationController.getBallAnimation();
        ballAnimation.timeline.play();
    }

    handleBallAnimationCompleteReplay(repliedBetData) {
        winningAmountStore.setWinNumber(repliedBetData.roundData.number);
        this.handleBetWinning(repliedBetData?.additionalParams);
        setTimeout(() => {
            // loadThree.camera2();
        }, 1000);
    }
}

export const gameService = new GameService();
